import { render, staticRenderFns } from "./CreateMovement.vue?vue&type=template&id=0856a33c&scoped=true&"
import script from "./CreateMovement.vue?vue&type=script&lang=js&"
export * from "./CreateMovement.vue?vue&type=script&lang=js&"
import style0 from "./CreateMovement.vue?vue&type=style&index=0&id=0856a33c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0856a33c",
  null
  
)

export default component.exports